import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";

const procesos = [
  {
    titulo: "Proceso Comercial IT",
    descripcion:
      "El propósito principal de tener un proceso comercial completo " +
      "es garantizar la entrega eficiente, rentable y con alta calidad " +
      "de los servicios ofrecidos, asegurando una experiencia positiva " +
      "y continua para el cliente a lo largo de todo el ciclo de vida " +
      "del proyecto. Desde el primer contacto en preventa hasta el " +
      "seguimiento postventa, este proceso permite alinear los esfuerzos " +
      "de las áreas comerciales, técnicas y operativas bajo un mismo " +
      "enfoque ágil, escalable y medible.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-completo-it/proceso-comercial-completo" },
    ],
  },
  {
    titulo: "01 Generación de Demanda Omnicanal",
    descripcion:
      "El proceso de generación de demanda " +
      "omnicanal busca atraer y convertir prospectos de múltiples " +
      "canales (digitales, físicos, directos e indirectos), " +
      "asegurando una experiencia unificada, personalizada y continua.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-completo-it/generacion-demanda-omnicanal" },
    ],
  },
  {
    titulo: "02 Asignación de Cuentas y Segmentación de Oportunidades",
    descripcion:
      "Organizar y distribuir las cuentas y oportunidades " +
      "de forma estratégica para maximizar el potencial de cierre y la atención " +
      "personalizada. Asegurando que los Ejecutivos de cuenta o consultores " +
      "trabajen con las oportunidades correctas, en función de su perfil, " +
      "experiencia, maximizando la conversión y atención efectiva.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-completo-it/asignacion-cuentas-segmentacion-oportunidades" },
    ],
  },
  {
    titulo: "03 Análisis de Requerimientos",
    descripcion:
      "Levantar información precisa sobre las necesidades " +
      "del cliente para dimensionar correctamente el proyecto desde el inicio. " +
      "Evitando desviaciones que afecten los tiempos, presupuesto o calidad de " +
      "entrega, y asegurar que el cliente reciba lo que realmente necesita.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-completo-it/analisis-requerimientos" },
    ],
  },
  {
    titulo: "04 Diseño de Solución y Propuesta Técnico-Comercial",
    descripcion:
      "Transformar los requerimientos en una solución " +
      "concreta con arquitectura, servicios, tiempos y costos definidos. " +
      "Garantizando que lo ofrecido al cliente sea ejecutable, rentable y " +
      "cumpla con las expectativas.",
    acciones: [
      { label: "Procedimiento", to: "/proceso-completo-it/disenio-solucion-propuesta-tecnico-comercial" },
      { label: "Matriz RACI", to: "/proceso-completo-it/disenio-solucion-propuesta-tecnico-comercial-raci" },
    ],
  },
  {
    titulo: "06 Fase de Negociación y Cierre",
    descripcion: "Lograr la aceptación formal del cliente y la firma del contrato",
    acciones: [
      { label: "Procedimiento", to: "/proceso-completo-it/fase-negociacion-cierre" },
    ],
  },
];

const ProcesoCompleto = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Proceso Comercial IT</h1>
        </div>
        <div className="orgproc-grid-3col">
          {procesos.map((proceso, index) => (
            <div className="orgproc-card" key={proceso.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{proceso.titulo}</div>
                <p className="orgproc-card-desc">{proceso.descripcion}</p>
                <div className="orgproc-card-actions">
                  {proceso.acciones.map((accion) => (
                    <Link
                      className="orgproc-card-btn"
                      to={accion.to}
                      key={accion.to}
                    >
                      {accion.label} →
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default ProcesoCompleto;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
